import React, { ReactNode } from 'react';

interface TextProps {
  variant?: 'title' | 'subtitle' | 'body' | 'caption' | 'small';
  children: ReactNode;
  className?: string;
}

const Text: React.FC<TextProps> = ({ variant = 'body', children, className = '' }) => {
    const variants = {
      title: 'text-2xl sm:text-3xl font-bold text-foreground',
      subtitle: 'text-base sm:text-lg font-semibold text-foreground',
      body: 'text-sm sm:text-base text-muted-foreground leading-relaxed',
      caption: 'text-xs sm:text-sm text-muted-foreground',
      small: 'text-xs sm:text-sm text-muted-foreground'
    };
    
    const Component = variant === 'title' ? 'h3' : variant === 'subtitle' ? 'h4' : 'p';
    
    return (
      <Component className={`${variants[variant]} ${className}`}>
        {children}
      </Component>
    );
  };

  export default Text;